import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { api3Get, api3Post } from '../api/api3Client';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import { Flex, Divider, Text, Heading, Button} from '@aws-amplify/ui-react';
import Vehicleserviceraccess from './vehicleserviceraccess';

export default function Vehiclecommands({userJwt, vehicleId}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [can_unlock, updateCanUnlock] = React.useState(false);
  const [can_enable, updateCanEnable] = React.useState(false);
  const [can_lock, updateCanLock] = React.useState(false);
  const [can_disable, updateCanDisable] = React.useState(false);
  const [can_check_fix_telemetry, updateCanCheckFixTelemetry] = React.useState(false);
  const [can_location, updateCanLocation] = React.useState(false);
  const [showCommandResponse, updateShowCommandResponse] = React.useState(true);
  const [command_response, updateCommandResponse] = React.useState([]);
  const [commandId, updateCommandId] = React.useState(false);

  const getVehicleCommands = async () => {
    updateIsLoading(true);
    if(vehicleId)
    {
      var carId = vehicleId;
      if(carId > 0)
      {
        //console.log('vehiclecommands vehicle '+carId);
        try {
          const res = await api3Get(`/vehicles/${encodeURIComponent(carId)}/commands`)
          //console.log(JSON.stringify(myInit)); // temporary
          //console.log(JSON.stringify(res)); // temporary
          //console.log(res['vehicle_commands']);
          var vehicleCommands = []
          if('vehicle_commands' in res)
          {
            vehicleCommands = res['vehicle_commands'];
            //console.log('vehicleCommands: '+vehicleCommands)
          }
          if(vehicleCommands.includes('lock'))
          {
            updateCanLock(true);
          }
          if(vehicleCommands.includes('unlock'))
          {
            updateCanUnlock(true);
          }
          if(vehicleCommands.includes('enable'))
          {
            updateCanEnable(true);
          }
          if(vehicleCommands.includes('disable'))
          {
            updateCanDisable(true);
          }
          if(vehicleCommands.includes('location'))
          {
            updateCanLocation(true);
          }
          if(vehicleCommands.includes('check_fix_telemetry'))
          {
            updateCanCheckFixTelemetry(true);
          }
        } catch (e) {
          console.log('error fetching vehicle commands: ' + JSON.stringify(e))
        }
      }
    }
    updateIsLoading(false);
  }
  
  useEffect(() => {
    getVehicleCommands();
  },[userJwt])


  async function sendCommand(vehicleCommand) {
    updateIsLoading(true)
    try {
        const res = await api3Post(`/vehicles/${encodeURIComponent(vehicleId)}/commands`, {
          vehicle_command: vehicleCommand,
          command: 'SEND',
        })
        updateCommandResponse(res);
        if (res && 'command_id' in res) {
          updateCommandId(res['command_id']);
        }
    }
    catch (e) {
        console.log(JSON.stringify(e))
        updateCommandResponse({'error': e.message || String(e)});
    }
    updateIsLoading(false)
  }

  async function sendLocation() { return sendCommand('location'); }
  async function sendLock() { return sendCommand('lock'); }
  async function sendUnlock() { return sendCommand('unlock'); }
  async function sendEnable() { return sendCommand('enable'); }
  async function sendDisable() { return sendCommand('disable'); }
  async function sendCheckFixTelemetry() { return sendCommand('check_fix_telemetry'); }

  async function getRequestUpdate(requestId) {
    updateIsLoading(true)
    try {
        const res = await api3Post(`/vehicles/${encodeURIComponent(vehicleId)}/commands`, {
          command: 'CHECK',
          vehicle_command_id: requestId,
        })
        updateCommandResponse(res);
    }
    catch (e) {
        console.log(JSON.stringify(e))
        updateCommandResponse({'error': e.message || String(e)});
    }
    updateIsLoading(false)
  }


  return (
    is_loading ? <Loadingmini /> :
      <div className="command-board">
        <Heading level={2}>Vehicle Commands</Heading>
        <div className="command-sections">
          <section>
            <Heading level={4}>Unlock & Enable</Heading>
            { can_unlock
              ? <Button onClick={() => sendUnlock()}>UNLOCK DOORS</Button>
              : <Button backgroundColor={'#9E9E9E'}>UNLOCK DOORS UNAVAILABLE</Button>
            }
            { can_enable
              ? <Button onClick={() => sendEnable()}>ENABLE ENGINE</Button>
              : <Button backgroundColor={'#9E9E9E'}>ENABLE ENGINE UNAVAILABLE</Button>
            }
          </section>
          <section>
            <Heading level={4}>Lock & Disable</Heading>
            { can_lock
              ? <Button onClick={() => sendLock()}>LOCK DOORS</Button>
              : <Button backgroundColor={'#9E9E9E'}>LOCK DOORS UNAVAILABLE</Button>
            }
            { can_disable
              ? <Button onClick={() => sendDisable()}>DISABLE ENGINE</Button>
              : <Button backgroundColor={'#9E9E9E'}>DISABLE ENGINE UNAVAILABLE</Button>
            }
          </section>
          <section>
            <Heading level={4}>Other Commands</Heading>
            <Vehicleserviceraccess vehicleId={vehicleId} />
            { can_location ? <Button onClick={() => sendLocation()}>GET LOCATION</Button> : null }
            { can_check_fix_telemetry ? <Button onClick={() => sendCheckFixTelemetry()}>TROUBLESHOOT API</Button> : null }
          </section>
        </div>
        {
          command_response.length < 1 ? null :
          showCommandResponse === false ?
              <Flex direction="column">
                <Divider />
                <Button onClick={() => updateShowCommandResponse(true)}>
                  SHOW SERVER RESPONSE
                </Button>
              </Flex>
          :
              <Flex direction="column">
                <Divider />
                <Heading level={4}>Server Response</Heading>
                <Text>{JSON.stringify(command_response)}</Text>
                {
                  commandId === false ? null :
                  <Button onClick={() => getRequestUpdate(commandId)}>
                    GET STATUS UPDATE
                  </Button>
                }
                <Button onClick={() => updateShowCommandResponse(false)}>
                  HIDE SERVER RESPONSE
                </Button>
              </Flex>
        }
      </div>
  );
}